import { render, staticRenderFns } from "./splash-hero.vue?vue&type=template&id=61ae41dd&"
import script from "./splash-hero.vue?vue&type=script&lang=js&"
export * from "./splash-hero.vue?vue&type=script&lang=js&"
import style0 from "./splash-hero.vue?vue&type=style&index=0&id=61ae41dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports